import React, { Fragment } from 'react';

const Navigation = ({ links = [], contentLink = null, level = 0 }) => {
    let menuRef = React.createRef();
    let menuButtonRef = React.createRef();
    function toggleMenu() {
        menuRef.current.classList.toggle('navbar__menu--show');
        !contentLink && menuButtonRef.current.classList.toggle('navbar__icon--close');
    }
    const additionClass = contentLink && contentLink.attributes ? contentLink.attributes.cssValue : null;
    const hasChildrenClass = links.length > 0 ? 'has-children' : null;
    const nextLevel = level + 1;

    return (
        <Fragment>
            {!contentLink ?
                <a className="navbar__link--block navbar__icon--menu navbar__icon" ref={menuButtonRef} onClick={toggleMenu} />
                :
                <Fragment>
                    <a className={`navbar__link ${hasChildrenClass || ''} ${additionClass || ''}`} href={contentLink.url || '#'}>
                        <span dangerouslySetInnerHTML={{ __html: contentLink.name }} />
                    </a>
                    {links.length > 0 &&
                        <i className="navbar__icon--caret-right navbar__icon navbar__icon--open" onClick={toggleMenu}></i>
                    }
                </Fragment>
            }

            {level === 1 ? (
                <div className="navbar__menu-container">
                    {links.length > 0 &&
                        <ul className="navbar__menu" ref={menuRef} test={links.length}>
                            <NavigationHeader {...{ contentLink, toggleMenu }} />
                            {links.length > 0 && links.map((link, i) => !link.name ? null :
                                <li className="navbar__item" key={`${link.name}-${i}`}>
                                    <Navigation links={link.links} contentLink={link} level={nextLevel} />
                                </li>
                            )}
                        </ul>
                    }
                </div>
            ) : (
                    <Fragment>
                        {links.length > 0 &&
                            <ul className="navbar__menu" ref={menuRef} test={links.length}>
                                <NavigationHeader {...{ contentLink, toggleMenu }} />
                                {links.length > 0 && links.map((link, i) => !link.name ? null :
                                    <li className="navbar__item" key={`${link.name}-${i}`}>
                                        <Navigation links={link.links} contentLink={link} level={nextLevel} />
                                    </li>
                                )}
                            </ul>
                        }
                    </Fragment>
                )}
        </Fragment>
    );
};

const NavigationHeader = ({ contentLink, toggleMenu }) =>
    <Fragment>
        {!contentLink ? null : (
            <div className="navbar__menu-header">
                <i className="navbar__icon--caret-left navbar__icon" onClick={toggleMenu}></i>
                <span className="navbar__title" onClick={toggleMenu} dangerouslySetInnerHTML={{ __html: contentLink.name }}></span>
            </div>
        )}
    </Fragment>

export default Navigation;